import { show as showIntercom } from '@intercom/messenger-js-sdk'
import { Anchor, Divider, Space, Stack } from '@mantine/core'
import cn from 'classnames'

import { NavAnchor, NavAnchorHref } from '#components/NavAnchor'
import { OutsideAnchor } from '#components/OutsideAnchor'

import styles from './OnboardingLinks.module.scss'

const handleContactSupport = () => {
  if (window.intercomSettings) showIntercom()
}

type OnboardingLinkType = 'forgotpassword' | 'support' | 'backtologin'
type OnboardingLinkItem = OnboardingLinkType | 'divider'

const linkHref: Partial<Record<OnboardingLinkType, NavAnchorHref>> = {
  forgotpassword: '/forgot-password',
  backtologin: '/login',
}

const linkText: Record<OnboardingLinkType, string> = {
  forgotpassword: 'Forgot Password?',
  support: 'Contact Support',
  backtologin: 'Back to Sign In',
}

type TermsOfUseLinkType = 'terms' | 'privacy' | 'retention'

const termsOfUseHref: Record<TermsOfUseLinkType, string> = {
  terms: 'https://www.scripto.live/terms',
  privacy: 'https://www.scripto.live/privacy',
  retention: 'https://www.scripto.live/data-retention-policy',
}

const termsOfUseText: Record<TermsOfUseLinkType, string> = {
  terms: 'Terms of Service',
  privacy: 'Privacy Policy',
  retention: 'Data Retention Policy',
}

export const TermsOfUseLink = ({ type }: { type: TermsOfUseLinkType }) => (
  <OutsideAnchor
    href={termsOfUseHref[type]}
    className={styles.onboardingLink}
    withIcon={false}
  >
    {termsOfUseText[type]}
  </OutsideAnchor>
)

const OnboardingLink = ({ type }: { type: OnboardingLinkType }) => {
  const href = linkHref[type]

  if (href) {
    return (
      <NavAnchor
        href={href}
        className={styles.onboardingLink}
        onClick={type === 'support' ? handleContactSupport : undefined}
        tabIndex={0}
      >
        {type === 'backtologin' && (
          <i className={cn('fas fa-arrow-left-long', styles.backarrow)} />
        )}
        {linkText[type]}
      </NavAnchor>
    )
  }
  return (
    <Anchor
      href={href}
      className={styles.onboardingLink}
      onClick={type === 'support' ? handleContactSupport : undefined}
      tabIndex={0}
    >
      {type === 'backtologin' && (
        <i className={cn('fas fa-arrow-left-long', styles.backarrow)} />
      )}
      {linkText[type]}
    </Anchor>
  )
}

export const OnboardingLinks = ({ types }: { types: OnboardingLinkItem[] }) => (
  <>
    <Space h="xs" />
    <Stack gap="sm" align="center">
      {types.map((type) => {
        return type === 'divider' ? (
          <Divider size="xs" key="divider" className={styles.divider} />
        ) : (
          <OnboardingLink type={type} key={type} />
        )
      })}
    </Stack>
  </>
)
